export const GET_VISUALIZATION = 'GET_VISUALIZATION';
export const REMOVE_VISUALIZATION = 'REMOVE_VISUALIZATION';
